import { Fragment } from "react";
import { Typography, Box, Stack } from "@mui/material";
import { Container } from "@/components/atoms/index";
import { useStatsContext } from "@/providers/contexts/index";
import { ErrorState, LoadingState } from "../States/";
import { SearchPanel } from "@/components/organisms";
import SubscribeButton from "@/components/organisms/SubscribeButton";

export const Home = () => {
  const {
    totalCompanies,
    totalJobPosts,
    // totalHealthcareDomains,
    error,
    loading,
  } = useStatsContext();

  const stats = [
    { label: "Total Companies", value: totalCompanies },
    { label: "Total Jobs", value: totalJobPosts },
    // { label: "Total Healthcare Domains", value: totalHealthcareDomains },
  ];

  return (
    <Container
      componentName="home"
      sx={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {error ? (
        <ErrorState errors={error} />
      ) : loading ? (
        <LoadingState />
      ) : (
        <>
          <Typography variant="h1" gutterBottom>
            Welcome!
          </Typography>

          <Stack direction="row" alignItems="center" spacing={2}>
            {stats.map((stat, index) => (
              <Fragment key={stat.label}>
                <Stack spacing={0.5} alignItems="center">
                  <Typography variant="subtitle1">{stat.label}</Typography>
                  <Typography variant="h4">{stat.value}</Typography>
                </Stack>
                {index < stats.length - 1 && (
                  <Typography variant="h4">|</Typography>
                )}
              </Fragment>
            ))}
          </Stack>

          <Box mt={4} width="100%" maxWidth={600}>
            <SearchPanel renderDomainFilter renderSubmitButton page="search" />
          </Box>
        </>
      )}
      <Box
        sx={{
          position: "fixed",
          bottom: 125,
          right: 16,
          zIndex: 1000,
        }}
      >
        <SubscribeButton />
      </Box>
    </Container>
  );
};
